import { gql } from '@apollo/client';
const TENANT_ORDER_OPERATOR = gql `
  fragment TenantOrderOperatorFragment on OrderOperatorNode {
    id
    name
    vatNumber
    countryOfOrigin
    addressPostalCode
    addressCity
    addressStreet
    addressNumber
    emailAddress
    contactPhone
    status
    isOrderOperatorRemovable
    canNameBeUpdated
  }
`;
export default TENANT_ORDER_OPERATOR;
